/** Kurzes haptisches Feedback bei Phasenwechsel, Stimmabgabe, Countdown und Eliminierung. */
export function vibrate(pattern: number | number[]): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  navigator.vibrate(pattern);
}

export const haptics = {
  tick: () => vibrate(15),
  phaseChange: () => vibrate([20, 40, 20]),
  voteCast: () => vibrate(25),
  eliminated: () => vibrate([30, 60, 30, 60, 30]),
  gameOver: () => vibrate([40, 80, 40, 80, 120]),
};
